import createIcon from '../../icons/createIcon';

const IconCloseCircleFilled = createIcon('IconCloseCircleFilled', '0 0 32 32', [
    [
        'path',
        {
            'fill-rule': 'evenodd',
            'clip-rule': 'evenodd',
            d: 'M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16ZM5.1 14.05C5.1 14.0776 5.07761 14.1 5.05 14.1C5.02239 14.1 5 14.0776 5 14.05C5 14.0224 5.02239 14 5.05 14C5.07761 14 5.1 14.0224 5.1 14.05ZM12.7071 11.2929L12 10.5858L10.5858 12L11.2929 12.7071L14.5858 16.0001L11.293 19.2929L10.5859 20L12.0001 21.4142L12.7072 20.7071L16.0001 17.4143L19.2929 20.7071L20 21.4142L21.4142 20L20.7071 19.2929L17.4143 16.0001L20.7072 12.7071L21.4143 12L20.0001 10.5858L19.293 11.2929L16.0001 14.5858L12.7071 11.2929Z',
            fill: '#191B21',
            key: '5864f2'
        },
        []
    ]
]);

export { IconCloseCircleFilled };
